import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MatLabel } from '@angular/material/form-field';

@Component({
	selector: 'app-course-topic-dialog-box',
	standalone: true,
	imports: [CommonModule, MatDialogModule, MatLabel, MatDividerModule, MatIconModule, MatButtonModule
		, MatInputModule, MatFormFieldModule, FormsModule, ReactiveFormsModule, MatDividerModule,
	],
	templateUrl: './course-topic-dialog-box.component.html',
	styleUrl: './course-topic-dialog-box.component.scss'
})
export class CourseTopicDialogBoxComponent implements OnInit {
   
	topicForm: FormGroup;
	isEditMode = false;

	constructor(
		private fb: FormBuilder,
		@Inject(MAT_DIALOG_DATA) public data: { type?: string; payload?: any },
		private dialogRef: MatDialogRef<CourseTopicDialogBoxComponent>
	) {
		this.topicForm = this.fb.group({
			topic_title: ['', Validators.required],
			description: [''],
			subtopics: this.fb.array([])
		});
	}

	ngOnInit(): void {
		this.isEditMode = this.data?.type === 'edit' && !!this.data?.payload;

		if (this.isEditMode) {
			this.patchForm(this.data.payload);
		} else {
			this.addSubtopic();
		}
	}

	get subtopics(): FormArray {
		return this.topicForm.get('subtopics') as FormArray;
	}

	createReferenceLink(url: string = ''): FormGroup {
		return this.fb.group({
			url: [url]
		});
	}

	createSubtopic(subtopic: any = {}): FormGroup {
		return this.fb.group({
			subtopic_title: [subtopic.subtopic_title || ''],
			description: [subtopic.description || ''],
			reference_links: this.fb.array(
				(subtopic.reference_links || []).map((link: string) => this.createReferenceLink(link))
			)
		});
	}


	addSubtopic(): void {
		this.subtopics.push(this.createSubtopic());
	}

	removeSubtopic(index: number): void {
		this.subtopics.removeAt(index);
	}

	getReferenceLinks(subtopicIndex: number): FormArray {
		return this.subtopics.at(subtopicIndex).get('reference_links') as FormArray;
	}

	addReferenceLink(subtopicIndex: number): void {
		this.getReferenceLinks(subtopicIndex).push(this.createReferenceLink());
	}

	removeReferenceLink(subtopicIndex: number, linkIndex: number): void {
		this.getReferenceLinks(subtopicIndex).removeAt(linkIndex);
	}

	patchForm(topicData: any): void {
		this.topicForm.patchValue({
			topic_title: topicData.topic_title,
			description: topicData.description || ''
		});

		this.subtopics.clear();
		topicData.subtopics?.forEach((sub: any) => {
			this.subtopics.push(this.createSubtopic(sub));
		});
	}

	save(): void {
		if (this.topicForm.invalid) return;

		const formValue = this.topicForm.value;

		const transformedSubtopics = formValue.subtopics.map((sub: any) => ({
			subtopic_title: sub.subtopic_title,
			description: sub.description,
			reference_links: sub.reference_links
				.map((link: any) => link.url)
				.filter((url: string) => !!url.trim())
		}));

		const resultPayload = {
			topic_title: formValue.topic_title,
			description: formValue.description,
			subtopics: transformedSubtopics
		};

		this.dialogRef.close(resultPayload);
	}

	close(){
		this.dialogRef.close();
	}

}